import React from 'react';
import ArrowBack from '@material-ui/icons/ArrowBack';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment/moment';
import styled from 'styled-components';
import CriteriaImage from 'CriteriaImage';

const TicketTitleWrapper = styled.h2`
  display: inline-block;
  &:hover {
    font-weight: bold;
    // outline: solid white 1px;
    box-shadow: 0 1px 0 white;
    cursor: pointer;
  }

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box;
`;
const CriteriaWraper = styled.div`
  padding-top: 3px;
  width: 250px;
`;
const Criteria2Wraper = styled.p`
  width: 250px;
  font-size: 12px !important;
  color: grey;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const P = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const TicketLocation = styled.span`
  font-weight: 100;
`;

class SealDealSubHeader extends React.Component {
  state = {
    current: moment(),
  };
  interval;
  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ current: moment() }),
      60000
    );
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderQueryCriteria = () => {
    let returnString = [];
    returnString[1] = '';
    returnString[2] = '';
    if (this.props.ticket && this.props.ticket.ticketCriteria) {
      this.props.ticket.ticketCriteria.forEach((qCriteria, index) => {
        // returnString[qCriteria.hierarchy] += qCriteria.name;
        // if (qCriteria.value) {
        //   returnString[qCriteria.hierarchy] += ' ';
        //   returnString[qCriteria.hierarchy] += qCriteria.value.toString();
        //   if (qCriteria.unit) {
        //     returnString[qCriteria.hierarchy] += qCriteria.unit.toString();
        //   }
        // }
        // if (this.props.ticket.ticketCriteria[index + 1]) {
        //   returnString[qCriteria.hierarchy] += ', ';
        // }
        if (
          !(
            qCriteria.criteriaId === 270 ||
            qCriteria.criteriaId === 323 ||
            qCriteria.criteriaId === 325 ||
            qCriteria.criteriaId === 391 ||
            qCriteria.criteriaId === 320 ||
            qCriteria.criteriaId === 132 ||
            qCriteria.criteriaId === 389 ||
            qCriteria.criteriaId === 318 ||
            qCriteria.criteriaId === 322 ||
            qCriteria.criteriaId === 321 ||
            qCriteria.criteriaId === 319 ||
            qCriteria.criteriaId === 324 ||
            qCriteria.criteriaId === 330
          )
        ) {
          returnString[qCriteria.hierarchy] += qCriteria.name;
        }
        if (qCriteria.criteriaId === 270) {
          returnString[qCriteria.hierarchy] += 'IP';
        }
        if (qCriteria.value) {
          returnString[qCriteria.hierarchy] += ' ';
          returnString[qCriteria.hierarchy] += qCriteria.value.toString();
          if (qCriteria.unit) {
            returnString[qCriteria.hierarchy] += qCriteria.unit.toString();
          }
        }
        if (this.props.ticket.ticketCriteria[index + 1]) {
          returnString[qCriteria.hierarchy] += ', ';
        }
      });
      return (
        // <CriteriaWraper className="t-secondary-14 ">

        //   {returnString[1]}
        // </CriteriaWraper>

        <CriteriaWraper>
          <P className="t-secondary-14 ">{returnString[1]}</P>
          <Criteria2Wraper className="t-secondary-12 ticket-title">
            {returnString[2]}
          </Criteria2Wraper>
        </CriteriaWraper>
        // <div>
        //   <p className="t-secondary-14 u-mrg-bot-10">{returnString[1]}</p>
        //   <p className="t-secondary-12 u-mrg-bot-5 ticket-title">
        //     {returnString[2]}
        //   </p>
        // </div>
      );
    }
  };

  convertMS = milliseconds => {
    var day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    return {
      day,
      hour,
      minute,
      seconds,
    };
  };
  renderExpiringScale = () => {
    let { ticket } = this.props;
    if (ticket && ticket.expiration) {
      let start = ticket.creatorInfo.dateCreated;
      let end = ticket.expiration;
      const stillUtcStart = moment.utc(start).toDate();
      const stillUtcEnd = moment.utc(end).toDate();
      start = moment(stillUtcStart).local();
      end = moment(stillUtcEnd).local();
      const current = this.state.current;
      const diff = end.diff(current);
      const remained = this.convertMS(diff);
      const scale =
        100 * (current.diff(start, 'days') / end.diff(start, 'days'));
      return (
        <div>
          {remained.day >= 0 && (
            <p className="t-secondary-12 u-mrg-bot-5 expiring-date">
              {`${remained.day}d ${remained.hour}h ${remained.minute}m `}
            </p>
          )}
          {remained.day < 0 && (
            <span className="t-secondary-12 c-red t-weight-b">Expired</span>
          )}
          <LinearProgress
            classes={{
              barColorPrimary:
                scale < 80
                  ? 'progres_bg_primary_white'
                  : 'progres_bg_secondary',
            }}
            variant="determinate"
            value={
              100 * (current.diff(start, 'days') / end.diff(start, 'days'))
            }
          />
        </div>
      );
    } else {
      return false;
    }
  };
  goBackToProject = projectId => () => {
    if (this.props.history.location.pathname.indexOf('slips') > -1) {
      // alert('your url contains the name franky');
      this.props.history.push('/demand/project/' + projectId);
    } else {
      this.props.history.goBack();
    }
  };

  goToViewTicket = (projectId, ticketId) => () => {
    this.props.history.push(
      '/demand/project/' + projectId + '/ticket/' + ticketId
    );
  };

  render() {
    return (
      // slips header
      <div className="sub-header -slips">
        <div className="sub-header-wrapper">
          <div className="active-ticket-information">
            <div
              onClick={this.goBackToProject(this.props.projectId)}
              className="arrow-back"
            >
              <ArrowBack />
            </div>
            <CriteriaImage
              mountingPosition={
                this.props.currentTicket
                  ? this.props.currentTicket.mountingPosition
                  : false
              }
              mountingType={
                this.props.currentTicket
                  ? this.props.currentTicket.mountingType
                  : false
              }
            />
            <div className="sub-header-content u-mrg-left-10">
              <div
                onClick={this.goToViewTicket(
                  this.props.projectId,
                  this.props.ticketId
                )}
                className="t-secondary-14 "
              >
                <TicketTitleWrapper className="t-primary-24">
                  {this.props.ticket ? this.props.ticket.referenceName : ''}{' '}
                  <TicketLocation>
                    {this.props.ticket ? this.props.ticket.name : ''}
                  </TicketLocation>
                </TicketTitleWrapper>
              </div>
              {this.renderQueryCriteria()}
            </div>
          </div>
          <div className="active-ticket-expiring">
            <p className="t-secondary-14 u-mrg-bot-15">
              <b>
                {this.props.ticket && this.props.ticket.state !== 'DRAFT'
                  ? 'Issued by: '
                  : 'Drafted by: '}
              </b>
              {this.props.ticket ? this.props.ticket.creatorInfo.createdBy : ''}
              , on{' '}
              {this.props.ticket
                ? moment(this.props.ticket.creatorInfo.dateCreated).format(
                    'MMM Do YYYY'
                  )
                : ''}
            </p>
            {this.props.ticket && this.props.ticket.state !== 'DRAFT' && (
              <React.Fragment>
                <p className="t-secondary-14 u-mrg-bot-10">
                  <b>Expires: </b>
                  {this.props.ticket
                    ? moment(this.props.ticket.expiration).format('MMM Do YYYY')
                    : ''}{' '}
                </p>
                {this.props.ticket && this.props.ticket.state !== 'DRAFT'
                  ? this.renderExpiringScale()
                  : null}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SealDealSubHeader;
